import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#0a0a0f] via-[#1a1a2e] to-[#0a0a0f] border-t border-white/10 mt-auto">
      <div className="max-w-[1400px] mx-auto px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-['Poppins'] text-lg font-bold mb-4">
              QUICK LINKS
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Work
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-['Poppins'] text-lg font-bold mb-4">
              GET IN TOUCH
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:charles.kilvington@outlook.com"
                  className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm"
                >
                  <Mail size={16} />
                  <span>Email</span>
                </a>
              </li>
              <li className="flex items-center gap-3 mt-4">
                <a
                  href="https://instagram.com/charleskilvington"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg bg-white/5 hover:bg-purple-500/20 transition-all"
                  aria-label="Instagram"
                >
                  <Instagram size={18} className="text-gray-400 hover:text-white transition-colors" />
                </a>
                <a
                  href="https://twitter.com/charleskilvington"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg bg-white/5 hover:bg-purple-500/20 transition-all"
                  aria-label="Twitter"
                >
                  <Twitter size={18} className="text-gray-400 hover:text-white transition-colors" />
                </a>
                <a
                  href="https://linkedin.com/in/charleskilvington"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg bg-white/5 hover:bg-purple-500/20 transition-all"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={18} className="text-gray-400 hover:text-white transition-colors" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Charles Kilvington. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-gray-500 hover:text-white transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-500 hover:text-white transition-colors text-sm">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
